"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = HelpMedium;

var _HelpMedium = require("@adobe/react-spectrum-ui/dist/HelpMedium");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function HelpMedium(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_HelpMedium.HelpMedium, null));
}